export default "__VITE_ASSET__1wM9qzb8__"